import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { TextField, FormControl, Autocomplete } from "@mui/material";
import { getAgentFilter } from "../Store/Actions/TicketAction";

const AssignAgentModal = ({
  agentToAssign,
  currentAssignedAgent,
  onClose,
  setAgentToAssign,
  setIsAssignAgentWarningShown,
}) => {
  const [agentList, setAgentList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    setIsLoading(true);

    getAgentFilter(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          setAgentList(
            response.data.filter(
              // Filter current assigned agent
              (agent) => agent.AgentID !== currentAssignedAgent
            )
          );

          setIsLoading(false);
        } else {
          console.log("error", response.error);
          toast.error("Error fetching agents", { autoClose: 3000 });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error fetching agents", { autoClose: 3000 });
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="overlayHistory">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="modalRight">
          <CloseOutlinedIcon className="closeBtn" onClick={onClose} />

          <div className="content">
            <h1>Assign Agent</h1>
          </div>

          <div className="AssignAgentBody">
            <div className="ContainerT1" style={{ marginTop: "40px" }}>
              <FormControl fullWidth>
                <Autocomplete
                  className="search-item status-selector"
                  disableClearable
                  loading={isLoading}
                  options={agentList}
                  value={agentToAssign}
                  getOptionLabel={(option) => option.AgentName}
                  onChange={(event, value) => {
                    setAgentToAssign(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Agent" />
                  )}
                />
              </FormControl>
            </div>
          </div>

          <div className="btnContainer">
            <button className="btn_Cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className={"btn_Confirm"}
              disabled={agentToAssign === null ? true : false}
              onClick={() => setIsAssignAgentWarningShown(true)}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignAgentModal;
